import React from 'react';
import { useIntl } from 'react-intl';
import { App } from '@gin-betting/core';

import { Loader, NoResults } from 'components';
import globalMessages from 'messages';

interface Props {
    error?: any;
    isTimeout?: boolean;
    isLoading?: boolean;
}

const MatchStub: React.FC<Props> = ({ isLoading, isTimeout, error }) => {
    const { formatMessage } = useIntl();

    const getFinalMessage = (): string => {
        if (isTimeout) {
            return formatMessage(globalMessages.timeIsUp);
        }

        return error && !isLoading
            ? formatMessage(globalMessages.uploadError)
            : formatMessage(globalMessages.loading);
    };

    const handleRefresh = () => {
        if (typeof window !== 'undefined') {
            window.location.reload();
        }
    };

    const finalMessage = getFinalMessage();

    return (
        <React.Fragment>
            {isLoading && (
                <Loader
                    initialProgressValue={0}
                    fetchStatus={App.FetchStatus.LOADING}
                />
            )}
            <NoResults
                type={App.PageType.INNER}
                defaultMessage={finalMessage}
                error={error && !isLoading}
                linkHandler={handleRefresh}
            />
        </React.Fragment>
    );
};

export default MatchStub;
